import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
const PrescriptionDetailsPage = () => (<Box sx={{ p: 3 }}><Card><CardContent><Typography variant="h4">Prescription Details</Typography><Typography>Coming soon</Typography></CardContent></Card></Box>);
export default PrescriptionDetailsPage;